export default __webpack_public_path__ + "static/media/USAtraveler.6730310a.jpg";